// @flow

import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  min-height: 400px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
`;

export const ErrorIcon = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: ${props => props.theme.colors.neutral[700]};
  margin-bottom: 12px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[500]};
  line-height: 1.5;
  margin-bottom: 32px;
  max-width: 280px;
`;

export const RetryButton = styled.button`
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral.white};
  background: ${props => props.theme.colors.new_primary[500]};
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: ${props => props.theme.colors.new_primary[600]};
  }
`;
